import ApiClient from './ApiClient';

class HistoryCtwaCampaigns extends ApiClient {
  constructor() {
    super('history_ctwa_campaigns', { accountScoped: true });
  }

  get(data) {
    return axios.get(this.url, {
      params: data
    });
  }
}

export default new HistoryCtwaCampaigns();
